module.exports = __webpack_public_path__ + "img/panel-options.41d166c8.png";